
import AppProductTableEditable from "@/components/products/ProductEditComposition.vue";
import AppTotals from "@/components/products-table/Totals.vue";
import { SellCategories } from "@/models/dossier-configs/sell-categories";
import { Product } from "@/models/base";
import { ProductCompositionRow } from "@/models/base";
import { ProductService } from "@/services/product-service";
import { VatService } from "@/services/vat-service";
import Vue from "vue";
import { ConfirmResult, ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			product: new Product(),
			loaded: false,
			selectedRow: null as ProductCompositionRow | null,
			pendingChanges: false,
			valid: true,
			sellCategoryNames: new SellCategories(),
			VatRegime: 1,
			PriceCategory: 1
		};
	},
	computed: {
		title(): string{
			return this.$ct("edit-composition").toString();
		},
		vatRegimeItems(): ISelectItem<number>[] {
			let regimeCount = VatService.getVatRegimeCount();
			let items = [] as ISelectItem<number>[];
			for (let i = 0; i < regimeCount; i++) {
				items.push({
					text: this.$ct("common.vat-regimes." + (i + 1)).toString(),
					value: i + 1
				});
			}
			return items;
		},
		selectablePriceCategories(): ISelectItem<number>[] {
			let res = [] as ISelectItem<number>[];
			for (let i = 1; i <= 10; i++) {
				res.push({
					text: this.sellCategoryNames.getCategoryName(i) || this.$ct("common.Category", {num: i}).toString(),
					value: i
				});
			}
			return res;
		}
	},
	watch: {
		product: {
			deep: true,
			handler(product: Product) {
				if (!this.loaded) return;
				this.pendingChanges = true;
			}
		},
		"product.Composition"(rows: ProductCompositionRow[]) {
			if (!rows) return;
			rows.forEach((row, i) => {
				row.DisplayOrder = i;
			});
		},
	},
	methods: {
		async onAddRow(row: { row: ProductCompositionRow, product: Product }) {

		},
		onSelectRow(row: ProductCompositionRow) {
			this.selectedRow = this.selectedRow == row ? null : row;
		},
		remove(row: ProductCompositionRow) {
			this.product.Composition.splice(this.product.Composition.indexOf(row), 1);
			if (this.selectedRow == row){
				this.selectedRow = null;
			}
		},
		async save() {
			for (let p of this.product.Composition) {
				if (p.ReferencedProductID == this.product.ID){
					let message = this.$ct("product-composition-cannot-reference-self", {sku: this.product.Sku});
					this.$wf.dialog(message, this.$ct("common.ok"), this.$ct("common.error"), "warning");
					return;
				}
			}
			this.product = await ProductService.putProduct(this.product);
			this.pendingChanges = false;
			this.back();
		},
		async askToSave(): Promise<ConfirmResult> {
			return this.$confirmBuilder(this.$t("common.confirmSave")).setWarningTitle().show();
		},
		async back() {
			if (this.pendingChanges) {
				let save = await this.askToSave();
				if (save) {
					return this.save();
				}
			}

			this.$router.push(`/products/edit/${this.product.ID}`);
		}
	},
	async mounted() {
		this.product = await ProductService.getProduct(parseInt(this.$route.params.id));
		this.loaded = true;
		requestAnimationFrame(()=>{
			this.pendingChanges = false;
		});
	},
	components: {
		AppProductTableEditable,
		AppTotals
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
